import { __assign } from "tslib";
import { getDefaultNetworkInformation } from '../utils';
export function getNetworkType(netInfo) {
    return (netInfo === null || netInfo === void 0 ? void 0 : netInfo.effectiveType) || (netInfo === null || netInfo === void 0 ? void 0 : netInfo.type) || '';
}
export var InjectNetworkTypePlugin = function (client) {
    var netInfo = getDefaultNetworkInformation();
    var network_type = getNetworkType(netInfo);
    if (netInfo) {
        netInfo.onchange = function () {
            network_type = getNetworkType(netInfo);
        };
    }
    client.on('report', function (ev) {
        return __assign(__assign({}, ev), { extra: __assign(__assign({}, (ev.extra || {})), { network_type: network_type }) });
    });
};
//# sourceMappingURL=inject-network-type.js.map